import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { CaseFooter } from '@/components/case/case-footer';
import {
  CaseBody,
  CaseMeta,
  CaseStatusPills,
  caseTitle,
} from '@/components/case/case-parts';
import { QueryState } from '@/components/feedback/query-state';
import { SkeletonSheet } from '@/components/feedback/skeletons';
import { PageHeader } from '@/components/page-header';
import { adminQuery } from '@/lib/query';

export const Route = createFileRoute('/_app/cases/$caseId')({
  component: CasePage,
});

/** One case on its own page: the same parts as the sheet. */
function CasePage() {
  const { caseId } = Route.useParams();
  const query = useQuery(adminQuery('cases.get', { case_id: caseId }));
  return (
    <QueryState query={query} label="this case" skeleton={<SkeletonSheet />}>
      {(item) => (
        <div className="flex max-w-4xl flex-col gap-6">
          <PageHeader
            title={caseTitle(item)}
            description={`Case ${item.id.slice(0, 8)}`}
            actions={<CaseStatusPills item={item} />}
          />
          <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-muted-foreground">
            <CaseMeta item={item} />
          </p>
          <CaseBody item={item} />
          <div className="rounded-lg border border-border bg-card p-4">
            <CaseFooter item={item} />
          </div>
        </div>
      )}
    </QueryState>
  );
}
